<section aria-labelledby="venue-location-heading" class="space-y-4">
  <div>
    <h2 class="text-base font-semibold" id="venue-location-heading">
      Venue location
    </h2>
    <p class="text-secondary mt-1 text-sm">
      Search and select a suggestion, then adjust the pin if the entrance is
      elsewhere.
    </p>
  </div>

  <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
    <mat-label>Search for the venue address</mat-label>
    <input
      #searchBox
      matInput
      autocomplete="off"
      [disabled]="disabled || !mapsAvailable"
      [value]="searchText"
      (input)="onSearchInput($any($event.target).value)"
      aria-describedby="venue-location-help"
    />
    <mat-hint id="venue-location-help">
      A location is confirmed only after you select a suggestion or place the
      pin.
    </mat-hint>
  </mat-form-field>

  <div class="flex flex-wrap gap-2">
    <button
      mat-stroked-button
      type="button"
      [disabled]="disabled || !mapsAvailable || isResolving"
      (click)="useCurrentLocation()"
    >
      <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
      Use current location
    </button>
  </div>

  <div
    *ngIf="mapsAvailable; else mapsUnavailable"
    class="overflow-hidden rounded-lg border"
  >
    <google-map
      height="300px"
      width="100%"
      [center]="center"
      [zoom]="zoom"
      [options]="mapOptions"
      (mapClick)="onMapClick($event)"
    >
      <map-marker
        *ngIf="selectedLocation?.markerPos as markerPos"
        [position]="markerPos"
        [options]="markerOptions"
        (mapDragend)="onMarkerDragEnd($event)"
      ></map-marker>
    </google-map>
  </div>
  <ng-template #mapsUnavailable>
    <div
      class="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800"
      role="alert"
    >
      The map is unavailable. Refresh the page before setting this venue's
      location.
    </div>
  </ng-template>

  <p class="text-secondary text-sm">
    Click the map or drag the marker to fine-tune the entrance position.
  </p>

  <div
    *ngIf="isResolving"
    class="flex items-center gap-2 text-sm"
    role="status"
  >
    <mat-spinner diameter="18"></mat-spinner>
    <span>{{ statusMessage }}</span>
  </div>

  <p *ngIf="errorMessage" class="text-warn-600 text-sm" role="alert">
    {{ errorMessage }}
  </p>
  <p
    *ngIf="showSelectionError && !errorMessage"
    class="text-warn-600 text-sm"
    role="alert"
  >
    Select a search suggestion or place the pin on the map to confirm the
    location.
  </p>

  <div
    *ngIf="selectedLocation"
    class="rounded-lg border border-green-200 bg-green-50 p-4"
    aria-live="polite"
  >
    <div class="flex items-center justify-between gap-4">
      <div class="font-semibold text-green-900">Location confirmed</div>
      <button mat-button type="button" (click)="openSelectedLocation()">
        Verify in Google Maps
      </button>
    </div>
  </div>
</section>
